import { useDispatch, useSelector } from "react-redux";

import { setShowVAT } from "../../reducers/settings";
import { settingsLocalStorageService } from "../../services/SettingsLocalStorageService";

const SwitchVAT = () => {
  const dispatch = useDispatch();
  const showVAT = useSelector((state) => state.settings.showVAT);

  const handleChange = (e) => {
    settingsLocalStorageService.setShowVAT(e.target.checked);
    dispatch(setShowVAT(e.target.checked));
  };

  return (
    <div className="form-check form-switch">
      <input
        className="form-check-input"
        type="checkbox"
        role="switch"
        id="flexSwitchCheckDefault"
        checked={showVAT}
        onChange={handleChange}
      />
      <label className="form-check-label" htmlFor="flexSwitchCheckDefault">
        {showVAT ? "M/MOMS" : "U/MOMS"}
      </label>
    </div>
  );
};

export default SwitchVAT;
